import { render } from "./shopRole.vue?vue&type=template&id=405530a9&scoped=true&ts=true"
import script from "./shopRole.vue?vue&type=script&lang=ts"
export * from "./shopRole.vue?vue&type=script&lang=ts"

import "./shopRole.vue?vue&type=style&index=0&id=405530a9&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405530a9"]])

export default __exports__